// Aviso discreto de conexão (painel e aluno), fixo no topo: "Reconectando…" enquanto alguma consulta está
// repetindo depois de falhar (rede caiu, API reiniciando no deploy — api/consultas.ts) e "Sem conexão" com o
// aparelho offline. Some sozinho quando volta; a tela continua com o que já tinha em vez de ficar vazia.
import { useIsFetching } from "@tanstack/react-query";
import { useOnline } from "../lib/hooks";
import { Icones } from "./icones";

export function Reconectando() {
  const online = useOnline();
  const repetindo = useIsFetching({ predicate: (q) => q.state.fetchFailureCount > 0 });
  if (online && repetindo === 0) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-[calc(env(safe-area-inset-top)+8px)] z-60 flex justify-center px-margem">
      <p
        role="status"
        aria-live="polite"
        data-reconectando=""
        className="flex items-center gap-2 rounded-full bg-tinta px-4 py-1.5 text-rotulo text-sobre-tinta shadow-toast animate-fade-entra"
      >
        <Icones.info size={16} aria-hidden className="shrink-0" />
        {online ? "Reconectando…" : "Sem conexão. Aguardando a internet…"}
      </p>
    </div>
  );
}
